export default __webpack_public_path__ + "static/media/dragon2.7ba009b0.jpg";